export default "__VITE_ASSET__D17oWiK3__"